import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const downloadPreferredTemplate = createAsyncThunk(
	"preferredTemplateDownload/downloadPreferredTemplate",
	async (channelId, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.get(`channel/${channelId}/unitDetails/preferred-template`, {
				responseType: "blob",
			});

			const blob = new Blob([response.data], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "preferred_unit_template.xlsx");
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);
			window.URL.revokeObjectURL(url);

			return { success: true };
		} catch (error) {
			return rejectWithValue(error.response?.data || "Download failed");
		}
	}
);

const initialState = {
	isLoading: false,
	isSuccess: false,
	error: null,
};

const preferredTemplateDownloadSlice = createSlice({
	name: "preferredTemplateDownload",
	initialState,
	reducers: {
		resetPreferredTemplateDownload: (state) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(downloadPreferredTemplate.pending, (state) => {
				state.isLoading = true;
				state.isSuccess = false;
				state.error = null;
			})
			.addCase(downloadPreferredTemplate.fulfilled, (state) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.error = null;
			})
			.addCase(downloadPreferredTemplate.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.error = action.payload;
			});
	},
});

export const { resetPreferredTemplateDownload } = preferredTemplateDownloadSlice.actions;
export default preferredTemplateDownloadSlice.reducer;

